import { render, staticRenderFns } from "./DlgHostSelector.vue?vue&type=template&id=54b9135a&scoped=true"
import script from "./DlgHostSelector.vue?vue&type=script&lang=ts"
export * from "./DlgHostSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b9135a",
  null
  
)

export default component.exports